const id_purch_invoice = {
    "": "tagihan pembelian",
    add: "buat tagihan pembelian",
    detail: "detail tagihan pembelian",
    edit: "ubah tagihan pembelian",

    label: {
        file: "bukti tagihan",
        date_create: "tanggal pembuatan tagihan",
        po_list_title: "daftar PO",
    },

    error: {
        create: "Gagal membuat tagihan pembelian.",
        edit: "Gagal mengubah tagihan pembelian.",
    },

    success: {
        create: "Berhasil membuat tagihan pembelian.",
        edit: "Berhasil mengubah tagihan pembelian.",
    },
}

export default id_purch_invoice;